import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Constant } from '../constant';

var jsonResponse: any;
@Injectable({
  providedIn: 'root'
})
export class FrameService {

  httpOptions = {
    headers:new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': 'Bearer ' + localStorage.getItem('access_token')
    })
  }

  formDataHttpOptions = {
    headers:new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem('access_token')
    })
  }

  constructor(private http: HttpClient, private constant: Constant) {

  }

  create(req): Observable<any> {
    return this.http.post<any>(this.constant.API_DOMAIN + '/api/v1/frame', req,
    this.formDataHttpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  update(req): Observable<any> {
    return this.http.post<any>(this.constant.API_DOMAIN + '/api/v1/frame-update', req,
    this.formDataHttpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  updateOrder(orders): Observable<any> {
    return this.http.post<any>(this.constant.API_DOMAIN + '/api/v1/frame-update-order', { orders },
    this.httpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  delete(id): Observable<any> {
    return this.http.delete<any>(this.constant.API_DOMAIN + '/api/v1/frame/' + id,
    this.httpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  // Error handling
  handleError(e) {
  console.log(e);
  if(e.error && e.error.message) {
    return throwError(e.error.message);
  }
  return throwError('');
  }
}